const inverseFieldPositioning = (pageDimensions, field) => {
  const newFieldCoordinates = {};
  newFieldCoordinates.x = field.x;
  newFieldCoordinates.y = pageDimensions.height - field.y;

  return newFieldCoordinates;
};

export default inverseFieldPositioning;
